import React from 'react';
import { Field } from 'formik';

import styles from './pressMediaFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import FileField from 'buyside/components/presentation/Form/Field/FileField/fileField';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const PressMediaForm = ({ setFieldValue }) => {
  const renderPressItem = (pressPath, press) => {
    const showFileField = typeof press.usePdf === 'undefined' ? !!press.filename : press.usePdf;
    return (
      <div>
        <div className={styles.pressRow}>
          <div className={styles.pressColumn}>
            <Field component={InputField} name={pressPath + '.title'} label="Title" />
          </div>
          <div className={styles.pressColumn}>
            <Field
              component={InputField}
              name={pressPath + '.publishDate'}
              type="date"
              label="Date Published"
            />
          </div>
        </div>
        <div className={styles.pressRow}>
          <div className={styles.pressColumn}>
            {showFileField ? (
              <Field
                component={FileField}
                name={pressPath}
                label="File"
                filefieldConfig={{ 'application/pdf': ['.pdf'] }}
              />
            ) : (
              <Field component={InputField} name={pressPath + '.url'} label="URL" />
            )}
            <Button
              text={showFileField ? 'Paste a URL instead?' : 'Upload a file instead?'}
              onClick={() => {
                setFieldValue(pressPath + (showFileField ? '.base64' : '.url'), '');
                setFieldValue(pressPath + '.usePdf', !showFileField);
              }}
              className={styles.insteadButton}
              type={BUTTON_TYPES.LINK}
              buttonType={BUTTON_TYPES.BUTTON}
            />
          </div>
        </div>
        <div className={styles.pressDescription}>
          <Field
            component={InputField}
            name={pressPath + '.description'}
            type="textarea"
            label="Description"
          />
        </div>
      </div>
    );
  };

  return (
    <AddRemoveForm
      title="Press Items"
      attr="fundProfile.presses"
      renderItem={renderPressItem}
      itemName="Press Item"
      blankItem={{ title: '', url: '', filename: '', publishDate: null, description: '' }}
    />
  );
};

export default PressMediaForm;
